import {Box, Typography} from '@mui/material';
import React from 'react';

import {MainFooter, MainHeader, PageWrapperLayout} from 'presentation/components';
import {Filter} from 'presentation/components/Filter';
import {GuidesEnum} from 'presentation/constants';
import {Districts} from 'presentation/modules/guide/shared/ui/components/DistrictSelection/components/Districts';
import {FlowType} from 'presentation/pages/private/store/locationStore/constants';
import {StyledBreadcrumbs} from 'presentation/pages/private/uf-selection/styles';
import {translations} from 'presentation/translations-new';
import {Link} from 'react-router-dom';
import {useHealthGuideDistricts} from './hooks/useHealthGuideDistricts';
import {Container} from './styles';

const {
	searchDistrict,
	selectDistrict,
	city,
	state: stateName,
	district,
} = translations['pt-br'].commons;

export function HealthGuideDistricts() {
	const {isMobile, pathCitySelection, handleClose, handleBack} = useHealthGuideDistricts();

	return (
		<PageWrapperLayout title={selectDistrict}>
			<MainHeader
				title={selectDistrict}
				handleBack={handleBack}
				handleClose={handleClose}
				variant="subRoute">
				<StyledBreadcrumbs>
					<Link to={GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_UF}>
						<Typography
							variant="body1"
							fontWeight={600}
							color="white"
							sx={{textDecoration: 'underline'}}>
							{stateName}
						</Typography>
					</Link>
					<Link to={pathCitySelection}>
						<Typography
							variant="body1"
							fontWeight={600}
							color="white"
							sx={{textDecoration: 'underline'}}>
							{city}
						</Typography>
					</Link>
					<Typography variant="body1" color="white">
						{district}
					</Typography>
				</StyledBreadcrumbs>
				<Filter.Root>
					<Filter.Search placeholder={searchDistrict} />
				</Filter.Root>
			</MainHeader>

			<Container>
				<Districts flowType={FlowType.HEALTH_GUIDE} />
			</Container>
			<Box mt="auto">
				<MainFooter customMarginBottom={isMobile ? '130px' : undefined} />
			</Box>
		</PageWrapperLayout>
	);
}
